import type { Navigation } from '../../interfaces/navigation'

export const navigations: Navigation[] = [
  {
    label: 'Home',
    path: 'home',
  },
  {
    label: 'Soluções',
    path: 'solutions',
  },
  {
    label: 'Cases',
    path: 'cases',
  },
  {
    label: 'Sobre',
    path: 'about',
  },
  {
    label: 'Contato',
    path: 'contact',
  },
  {
    label: 'Atendimento',
    path: 'atendimento',
    externalLink: 'https://tawk.to/chat/5d95168fdb28311764d6fbcf/default?locale=pt_BR',
  },
]
